import React, { useState, useEffect } from "react";

import userIcon from "../../../assets/images/user-icon.png";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import Create_icon from "../../../assets/images/create_icon.png";

import { NotificationManager } from "react-notifications";
import CatalogDiamondDataService from "../../../services/catalog-diamond.service";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DownloadBox from "../../../assets/images/download_sample_icon.png";
import HelpBook from "../../../assets/images/help_docs.png";
import idexLogo from "../../../assets/images/idex_logo.png";
import polygonLogo from "../../../assets/images/polygon_logo.png";
import rapnetLogo from "../../../assets/images/rapnet_logo.png";

import ExcellFormatIcon from "../../../assets/images/excelFormatIcon.png";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import axios from "axios";
import config from "../../../helper/config";
import { Button, Input, Modal, Select, Spin, Tooltip } from "antd";
import catalogColorstoneService from "../../../services/catalog-colorstone.service";

const UploadColorStoneFile = () => {
  const { t } = useTranslation();
  const { Option } = Select;

  const loadImg = (
    <span>
      If you would like to pull jewelry images directly from a URL (for example: https://www.gemfind.com/zoomimages/80785.jpg), please add a column named IsImageFromUrl in your file and set its value to 1.
    </span>
  );

  const replaceDetail = (
    <span>
      {" "}
      {t(
        "Inventory with Dealer Stock # not included in the upload will be deleted."
      )}{" "}
    </span>
  );

  const addDetail = (
    <span>
      {" "}
      {t(
        "Inventory with New Dealer Stock # will be added and existing Dealer Stock # will be updated. Dealer Stock # not included will remain untouched."
      )}{" "}
    </span>
  );

  /*Custom Binding Starts*/
  const [submitLoading1, setSubmitLoading1] = useState(false);
  const [submitLoading2, setSubmitLoading2] = useState(false);
  const [submitLoading3, setSubmitLoading3] = useState(false);
  const [submitLoading4, setSubmitLoading4] = useState(false);

  const [dealerId, setdealerId] = useState(0);
  const [columnId, setcolumnId] = useState(14);
  const location = useLocation();
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [uploadCertVisible, setUploadCertVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [visible6, setVisible6] = useState(false);
  const [visibleConfirmModal, setVisibleConfirmModal] = useState(false);

  useEffect(() => {
    if (location.state) {
      if (location.state.dealerData) {
        setdealerId(location.state.dealerData.dealerID);
      }
    } else {
      if (loginDetials) {
        if (loginDetials.responseData) {
          setdealerId(loginDetials.responseData.dealerId);

          handleGet3rdPartyProviderHeader(
            loginDetials.responseData.dealerId,
            ""
          );
        }
      }
    }
  }, []);
  const initialState = {
    ImagefileName: null,
    Imagefile: [],
    DatafileName: null,
    Datafile: [],
    Delimiter: "COMMA",
    IsServer: false,
    rbtnRemove: true,
    filetype: null,
    Error: {},
    UploadCertFileName: null,
    UploadCertFile: null,
    UploadCertFileType: null,
  };
  const [state, setState] = useState(initialState);

  const [thirdPartyData, setThirdPartyData] = useState({
    linkSelect: "",
    linkUrl: "",
    username: "",
    password: "",
    checkboxValue: false,
  });

  const [validations, setValidations] = useState({
    linkUrl: "",
    username: "",
    password: "",
  });

  const handlePassShowHide = () => {
    setShowPassword(!showPassword);
  };

  const fileUpload = async (e, name) => {
    let tempState = state;
    let allFiles = [];
    let selectedFiles = e.target.files[0];
    if (name == "Image") {
      if (e.target.files[0].name.match(/.(zip)$/i)) {
        if (selectedFiles) {
          allFiles.push(selectedFiles);

          tempState["Imagefile"] = allFiles;
          tempState["ImagefileName"] = allFiles[0].name;
          tempState.Error["Imagefile"] = null;
        }
      } else {
        tempState.Error["Imagefile"] = t("Please select zip file only.");
        tempState["Imagefile"] = null;
        tempState["ImagefileName"] = null;
      }
    } else if (name == "Data") {
      if (e.target.files[0].name.match(/.(csv|xls|txt|.xlsx)$/i)) {
        if (selectedFiles) {
          allFiles.push(selectedFiles);

          tempState["Datafile"] = allFiles;
          tempState["DatafileName"] = allFiles[0].name;
          tempState["filetype"] = allFiles[0].name.split(".")[1];
          tempState.Error["Datafile"] = null;
        }
      } else {
        tempState.Error["Datafile"] = t(
          "Please select .csv|xls|txt file only."
        );
        tempState["DatafileName"] = null;
        tempState["Datafile"] = null;
        tempState["filetype"] = null;
      }
    }

    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };

  const handleVisible6 = () => {
    setVisible6(true);
  };
  const handleOnOk = () => {
    setVisible6(false);
  };
  /*Upload Certificates file Starts*/
  const fileUploadCertificate = async (e, name) => {
    let tempState = state;
    let allCertFiles = [];
    let selectedFiles = e.target.files[0];
    allCertFiles.push(selectedFiles);
    tempState["UploadCertFile"] = allCertFiles;
    tempState["UploadCertFileName"] = allCertFiles[0].name;
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };
  /*Upload Certificates file Ends*/

  const handleUploadDiamondDataFile = (name) => {
    if (handleValidation(name)) {
      setSubmitLoading1(true);
      const formData = new FormData();

      formData.append("file", state.Datafile[0]);
      formData.append("dealerId", dealerId);
      formData.append("fileType", state.filetype.toUpperCase());
      formData.append("ReplaceAllChecked", state.rbtnRemove);
      formData.append("SummaryIDDia", 0);
      formData.append("ddlDELIMITERDia", state.Delimiter);

      try {
        catalogColorstoneService.UploadColorStoneDataFile(formData)
          .then((response) => {
            let message = response.data.message;
            let responseData = response.data.responseData;

            setSubmitLoading1(false);
            if (message === "Success") {
              {
                NotificationManager.success(t(responseData.lblMsgDia));
                handleVisible6();
              }

              state["Datafile"] = null;
              state["DatafileName"] = null;
              state.Error["Datafile"] = null;
              state["Delimiter"] = null;
              state["IsServer"] = false;
              setState((prevState) => ({
                ...prevState,
                ...state,
              }));
              document.getElementById("file-upload1").value = "";
            } else {
              if (message == "Invalid file extension")
                NotificationManager.error(
                  t("The uploaded file has an incorrect extension.")
                );
              else NotificationManager.error(t(responseData.lblMsgDia));
              state["Datafile"] = null;
              state["DatafileName"] = null;
              state.Error["Datafile"] = null;
              state["Delimiter"] = null;
              state["IsServer"] = false;
              setState((prevState) => ({
                ...prevState,
                ...state,
              }));
              document.getElementById("file-upload1").value = "";
            }
          })
          .catch((error) => {
            setSubmitLoading1(false);
            console.log(error);
          });
      } catch (error) {
        setSubmitLoading1(false);
        console.log(error);
      }
    }
  };

  const validateThirdPartyInputs = () => {
    let isValid = true;
    const errors = {};

    if (!thirdPartyData.linkUrl) {
      errors.linkUrl = "Please Enter Link URL";
      isValid = false;
    }

    if (!["POLYGON", "DIRECTLINK"].includes(thirdPartyData.linkSelect)) {
      if (!thirdPartyData.username) {
        errors.username = "Please Enter Username";
        isValid = false;
      }
      if (!thirdPartyData.password) {
        errors.password = "Please Enter Password";
        isValid = false;
      }
    }

    setValidations(errors);
    return isValid;
  };

  const handleDiamondUpload3rdParty = () => {
    if (!validateThirdPartyInputs()) return;

    setSubmitLoading4(true);
    const formData = new FormData();
    formData.append("dealerId", dealerId);
    formData.append("DrpValue", thirdPartyData.linkSelect);
    formData.append("txtLinkURL", thirdPartyData.linkUrl);
    formData.append("txtUserName", thirdPartyData.username);
    formData.append("txtPassword", thirdPartyData.password);
    formData.append("cbEnabled", thirdPartyData.checkboxValue || true);

    CatalogDiamondDataService.DiamondUpload3rdParty(formData)
      .then((response) => {
        const message = response.data.message;

        setSubmitLoading4(false);
        if (message === "Success") {
          NotificationManager.success(
            t("Diamond Information Updated Successfully.")
          );
        } else {
          NotificationManager.error(t("Diamond Information Not Updated."));
        }
      })
      .catch((error) => {
        NotificationManager.error(t("Diamond Information Not Updated."));
        setSubmitLoading4(false);
        console.error(error);
      });
  };
  const handleDownloadAttributesMapFile = () => {
    try {
      let inputData = {
        DealerID: Number(dealerId),
        // columnID: Number(columnId),
      };
      setSubmitLoading3(true);
      catalogColorstoneService.CreateCSVColorStones(inputData)
        .then((response) => {
          setSubmitLoading3(false);
          let fileName = dealerId + ".xlsx";

          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setSubmitLoading3(false);
          console.log(error);
        });
    } catch (error) {
      setSubmitLoading3(false);
      console.log(error);
    }
  };

  const handleValidation = (upName) => {
    let isValid = true;
    if (upName === "Upload1") {
      if (state.Imagefile === null) {
        state.Error["Imagefile"] = t("Please select image.");
        isValid = false;
      } else {
        if (state.Imagefile.length === 0) {
          state.Error["Imagefile"] = t("Please select image.");
          isValid = false;
        }
      }
    } else if (upName === "Upload2") {
      if (state.Datafile === null) {
        state.Error["Datafile"] = t("Please select file.");
        isValid = false;
      } else {
        if (state.Datafile.length === 0) {
          state.Error["Datafile"] = t("Please select file.");
          isValid = false;
        }
      }
      if (state.Delimiter === null) {
        state.Error["Delimiter"] = t("Please select delimiter.");
        isValid = false;
      }
    }

    setState((prevState) => ({
      ...prevState,
      ...state,
    }));

    return isValid;
  };

  // 3rd Party GET API

  const handleGet3rdPartyProvider = (id, type) => {
    try {
      let inputData = {
        dealerID: id,
        type: type,
      };
      setLoader(true);
      CatalogDiamondDataService.Get3rdPartyProvider(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setThirdPartyData({
              linkUrl: responseData.type == type ? responseData.linkURL : "",
              linkSelect: type == "" ? responseData.type : type,
              username: responseData.type == type ? responseData.username : "",
              password: responseData.type == type ? responseData.password : "",
              checkboxValue:
                responseData.type == type ? responseData.enabled : "",
            });
            setLoader(false);
          } else {
            setThirdPartyData({});
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleGet3rdPartyProviderHeader = (id) => {
    try {
      let inputData = {
        dealerID: id,
        type: "",
      };
      CatalogDiamondDataService.Get3rdPartyProviderHeader(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          let type = responseData.type;
          if (message === "Success") {
            handleGet3rdPartyProvider(loginDetials.responseData.dealerId, type);
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // End 3rd Party GET API
  function onChangeRadio(e, name) {
    let tempState = state;
    if (name === "ReplaceAll") {
      // alert("This option will override the data.");
      setVisibleConfirmModal(true);
      tempState["rbtnRemove"] = true;
    } else {
      tempState["rbtnRemove"] = false;
    }

    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  }
  function onChangeDrop(e, name) {
    let tempState = state;

    tempState[name] = e;
    tempState.Error["Delimiter"] = null;
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  }

  const handleSelectOnChange = (value) => {
    setThirdPartyData({
      linkSelect: value,
      linkUrl: "",
      username: "",
      password: "",
      checkboxValue: false,
    });
    setValidations({
      linkUrl: "",
      username: "",
      password: "",
    });
    handleGet3rdPartyProvider(loginDetials.responseData.dealerId, value);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setThirdPartyData((prev) => ({ ...prev, [name]: value }));
    setValidations((prev) => ({ ...prev, [name]: "" }));
  };

  function onSearch(val) {}
  const saveFile = () => {
    axios({
      url: `${config.BlobURL}gemfind2staging/StaticFiles/UploadJewelry/ImageGuideline%20(1).pdf`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ImageGuideline.pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  /* Modal functionality starts */
  const handleCancel = () => {
    setUploadCertVisible(false);
  };
  /* Modal functionality starts */
  return (
    <div className="prodetail__section">
      {loginDetials?.responseData?.vendorStatusID == 3 ? (
        <>{t("Please Contact GemFind to get Access.")}</>
      ) : (
        <div className="form__fields">
          <div className="col-md-12">
            <div className="prod__maindiv data__maping uplaod__file magento__mapping">
              <Spin spinning={submitLoading1}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="heading__block">
                      <h4 class="workarea__heading mt-0 mb-0">
                        {" "}
                        {t("Upload Your Data File")}{" "}
                      </h4>
                      <div className="right__btn">
                        <Link to={"/addSingleGemstone"}>
                          <button className="primary-btn mr-2">
                            <img src={Create_icon} alt="" />{" "}
                            {t("Add Individual")}
                          </button>
                        </Link>
                        <Button
                          className="primary-btn mobile__topspace"
                          onClick={handleDownloadAttributesMapFile}
                          loading={submitLoading3}
                        >
                          <i className="fa fa-download"></i>{" "}
                          {t("Download Data")}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="input__block">
                      <div className="col-md-12 image_block">
                        <div class="row">
                          <div className="col-lg-12">
                            <p>
                              {" "}
                              {t(
                                "Please keep your inventory current. Your gemstone inventory will be removed if not updated at least every 48 hours."
                              )}{" "}
                            </p>
                          </div>
                          <div class="col-lg-4 col-md-12">
                            <div className="divimage_block">
                              <label
                                htmlFor="file-upload1"
                                class="primary-btn choose_file_upload"
                              >
                                {t("Choose File")}
                              </label>
                              <input
                                id="file-upload1"
                                type="file"
                                onChange={(e) => fileUpload(e, "Data")}
                              />
                              {state.Error ? (
                                <div className="text-danger">
                                  {state.Error["Datafile"]}
                                </div>
                              ) : null}

                              {/* For No file choosen  */}
                              {state.DatafileName ? (
                                ""
                              ) : (
                                <span className="mb-4">
                                  {t("No File Choosen")}{" "}
                                  {/* <span className="text-red">*</span> */}
                                </span>
                              )}

                              {/* End */}
                              <span> {t("Xlsx/Txt/Csv Format")} </span>
                              <span className="">{state.DatafileName}</span>
                            </div>

                            <div className="choose_file_divimg d-none">
                              <img src={userIcon} alt="img" />
                              <span>x</span>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-12">
                            <div>
                              <Select
                                className="border__grey mobile-w-100"
                                optionFilterProp="children"
                                placeholder={t("Please Select Delimiter")}
                                style={{ width: 177 }}
                                value={state.Delimiter}
                                onChange={(e) => onChangeDrop(e, "Delimiter")}
                              >
                                {/* <Option value=""> {t("Select")} </Option> */}
                                <Option value="COMMA"> {t("Comma")} </Option>
                                <Option value="TAB"> {t("Tab")} </Option>
                              </Select>
                              {state.Error ? (
                                <div className="text-danger">
                                  {state.Error["Delimiter"]}
                                </div>
                              ) : null}

                              <div className="radio__block mt-3">
                                <div className="radio__btn">
                                  <input
                                    type="radio"
                                    id="dr"
                                    name="mt"
                                    className="mr-1"
                                    checked={state.rbtnRemove ? true : false}
                                    onChange={(e) =>
                                      onChangeRadio(e, "ReplaceAll")
                                    }
                                  />
                                  <label htmlFor="dr">
                                    {" "}
                                    {t("Replace All")}
                                  </label>
                                  <Tooltip
                                    placement="right"
                                    title={replaceDetail}
                                    className="ToolTip-Diamond ml-1"
                                  >
                                    <img src={UnionIcon} alt="" />
                                  </Tooltip>
                                </div>
                                <div className="radio__btn">
                                  <input
                                    type="radio"
                                    id="jr"
                                    name="mt"
                                    className="mr-1"
                                    checked={
                                      state.rbtnRemove == false ? true : false
                                    }
                                    onChange={(e) =>
                                      onChangeRadio(e, "AddUpdate")
                                    }
                                  />
                                  <label htmlFor="jr">
                                    {" "}
                                    {t("Add & Update")}
                                  </label>
                                  <Tooltip
                                    placement="right"
                                    title={addDetail}
                                    className="ToolTip-Diamond ml-1"
                                  >
                                    <img src={UnionIcon} alt="" />
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="help-doc-sp">
                                <img
                                  src={HelpBook}
                                  width="15px"
                                  height="15px"
                                />
                                <p>
                                  {t("Questions? View the")}
                                    <a
                                      href="/GuideLines/JC%20Gemstone%20Data%20Form.xlsx"
                                      download
                                    >{" "}
                                    {t("Gemstone Import")}{" "}</a>
                                  {t("Help Docs")}.
                                </p>
                              </div>
                              <Button
                                className="primary-btn"
                                onClick={(e) =>
                                  handleUploadDiamondDataFile("Upload2")
                                }
                              >
                                {t("Upload Data")}
                              </Button>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="format__img">
                              <img
                                src={ExcellFormatIcon}
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                  <div className="col-lg-3">
                    <div className="right__sec">
                      <h5>
                        {" "}
                        {t(
                          "Add new gemstones in bulk or make mass item updates"
                        )}
                        .{" "}
                      </h5>
                      <h5> {t("First time importing?")} </h5>
                      <ul>
                        <li>
                          <b> {t("Import Your Content")} </b>
                          <p>
                            {" "}
                            {t(
                              "Choose & upload your data or connect to a 3rd party"
                            )}
                            .{" "}
                          </p>
                        </li>
                        <li>
                          <b> {t("Wait For Confirmation")} </b>
                          <p>
                            {" "}
                            {t(
                              "You will receive an e-mail confirmation when your content has been uploaded."
                            )}{" "}
                          </p>
                        </li>
                      </ul>
                      <br />
                      <div className="row download__block">
                        <h5> {t("Preparing Your Data")} </h5>
                        <br />
                        <br />
                        <h5> {t("Download Templates")} </h5>
                        <br />
                        <div className="col-md-2 col-2">
                          <img src={DownloadBox} alt="download-box" />
                        </div>
                        <div className="col-md-10 col-10 mobile-p-0">
                          <a
                            href="/GuideLines/JC%20Gemstone%20Data%20Form.xlsx"
                            download
                          >
                            {t("Standard Gemstone Form")}
                          </a>
                          <br />
                        </div>

                        <br />
                      </div>
                      <br />
                    </div>
                  </div>
                  {/* Upload File */}

                  {/* For No Update File */}
                  {/* Upload Certificates modal starts */}
                  <div className="col-lg-12">
                    <Modal
                      title={t("Upload Certificates")}
                      className="modal__manageUser"
                      centered
                      width={600}
                      visible={uploadCertVisible}
                      onCancel={handleCancel}
                      footer={[
                        <Button onClick={handleCancel}>{t("Cancel")}</Button>,
                        <Button key="submit" type="primary">
                          {t("Save")}
                        </Button>,
                      ]}
                    >
                      <div className="col-lg-12">
                        <div className="modal__body">
                          <div className="col-lg-12">
                            <div className="form__fields">
                              <div className="divimage_block uploadCertsImgBlock">
                                <label
                                  htmlFor="certificate-upload1"
                                  class="primary-btn choose_file_upload"
                                >
                                  {t("Choose File")}
                                </label>
                                <input
                                  id="certificate-upload1"
                                  type="file"
                                  onChange={(e) => fileUploadCertificate(e)}
                                />
                                {state.UploadCertFileName ? (
                                  ""
                                ) : (
                                  <span className="mb-4">
                                    {t("No File Choosen")}{" "}
                                    {/* <span className="text-red">*</span> */}
                                  </span>
                                )}

                                {/* End */}
                                <span> {t("Zip Format")} </span>
                                <span className="">
                                  {state.UploadCertFileName}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      title={t("Confirmation")}
                      centered
                      visible={visibleConfirmModal}
                      onCancel={() => setVisibleConfirmModal(false)}
                      width={400}
                      footer={[
                        <Button
                          key="submit"
                          type="primary"
                          onClick={() => setVisibleConfirmModal(false)}
                        >
                          {t("Ok")}
                        </Button>,
                      ]}
                    >
                      <div className="text-center">
                        <h5> {t("This option will override the data.")} </h5>
                      </div>
                    </Modal>
                  </div>

                  {/* Upload Certificates modal ends */}
                </div>
              </Spin>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadColorStoneFile;
